//const Schema = require("lib/shared/Schema");
const APIClient = require("lib/web/APIClient");
//const ActionUtility = require("lib/shared/ActionUtility");
// const Queries = require("lib/shared/Queries");

export const createUserAlert = ({ userAlertData }) => dispatch =>
  APIClient.postUserAlerts(userAlertData);



// WEBPACK FOOTER //
// ./modules/lib/actions/UserAlertsActions.js